<a routerLink="/payment/add" class="btn btn-blue btn-hover-up w-100" *ngIf="type() === 1">
  <img class="mr-1" src="assets/images/icons/star.png"/>
  Unlock full report
</a>
<a routerLink="/payment/add" *ngIf="type() === 2">
  <img src="assets/images/icons/lock.png" class="icon-lock"/>
</a>
<a routerLink="/payment/add" *ngIf="type() === 3" class="btn btn-blue btn-lg btn-animated mt-3">
  <img width="16" class="mr-1" src="assets/images/icons/star.png"/>
  Unlock full report
</a>


<!--<span (click)="open()">-->
<!--  <a class="btn btn-blue btn-hover-up w-100" *ngIf="type === 1">-->
<!--    <img class="mr-1" src="assets/images/icons/star.png"/>-->
<!--    Unlock full report-->
<!--  </a>-->
<!--  <a *ngIf="type === 2">-->
<!--    <img src="assets/images/icons/lock.png" class="icon-lock"/>-->
<!--  </a>-->
<!--  <a *ngIf="type === 3" class="btn btn-blue btn-lg btn-animated mt-3">-->
<!--    <img width="16" class="mr-1" src="assets/images/icons/star.png"/>-->
<!--    Unlock full report-->
<!--  </a>-->
<!--</span>-->

<!--<ng-template #content let-modal>-->
<!--  <div class="modal-header bg-medium b-0">-->
<!--    <a type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">-->
<!--      <img aria-hidden="true" src="assets/images/icons/cancel.png" width="12"/>-->
<!--    </a>-->
<!--  </div>-->
<!--  <div class="modal-body bg-medium text-center pt-0 pb-4">-->
<!--&lt;!&ndash;    <h4 class="modal-title mb-lg-4" id="modal-basic-title">Pricing</h4>&ndash;&gt;-->
<!--    <h6 class="content-header mb-lg-4">Pricing</h6>-->
<!--    <h6 *ngIf="(paymentState | async).paymentLoader.loadingPricing">Loading...</h6>-->
<!--    <div class="btn-group my-sm-3 my-lg-5" *ngIf="options.length > 1">-->
<!--      <button class="btn btn-default" *ngFor="let option of options" (click)="setActualKey(option)" [ngClass]="actualKey === option?'btn-blue':''">-->
<!--        {{option}}-->
<!--        report<span *ngIf="option>1">s</span>-->
<!--      </button>-->
<!--    </div>-->
<!--    <div class="row section-content price mt-4" *ngIf="(paymentState | async).pricingProfile[actualKey] !== undefined">-->
<!--      <div class="col-lg-6" *ngFor="let price of getValues((paymentState | async).pricingProfile[actualKey])">-->
<!--        <app-price-box [price]="price"></app-price-box>-->
<!--      </div>-->
<!--    </div>-->
<!--&lt;!&ndash;    <img class="pricing-bg" src="assets/images/dots.png"/>&ndash;&gt;-->
<!--    <p class="text-medium font-weight-light my-4">You can cancel your subscription at any time</p>-->
<!--  </div>-->
<!--</ng-template>-->


<!--routerLink="/payment/add"-->
